export default __webpack_public_path__ + "daeae246022ef88584951e80ba064dda.woff2";